import { combineReducers } from 'redux'
import { fieldsReducer as fields } from '../lib/redux-fields'
import { listsReducer as lists } from '../lib/redux-lists'
import { updateStateOnStorageLoad } from './storage'

import app from '../app/reducer'
import config from '../config/reducer'
import users from '../users/reducer'
import device from '../device/reducer'
import companies from '../companies/reducer'
import locations from '../locations/reducer'
import drivers from '../drivers/reducer'
import results from '../results/reducer'
import attendances from '../attendances/reducer'
import auth from '../auth/reducer'
import map from '../map/reducer'
import downloads from '../downloads/reducer'

const configureReducer = () => {
  let reducer = combineReducers({
    app,
    config,
    lists,
    fields,
    users,
    device,
    companies,
    locations,
    drivers,
    attendances,
    results,
    auth,
    map,
    downloads,
  })

  reducer = updateStateOnStorageLoad(reducer)

  return reducer
}

export default configureReducer



// WEBPACK FOOTER //
// ./src/common/configure/reducer.js